import { temAcesso } from '@/shared/auth/temAcesso'

const Consultorias = () => import('./Consultorias.vue')
const Consultoria = () => import('./Consultoria.vue')

export default {
    path: 'consultorias',
    name: 'AppSebrae_Consultorias_Fornecedor_Consultorias',
    component: Consultorias,
    beforeEnter: (to, from, next) => {
        if (temAcesso('APPSE-FORN-CONS-00')) {
            next()
        }
    },
    children: [
        {
            path: ':consultoriaId',
            name: 'AppSebrae_Consultorias_Fornecedor_Consultorias_Detalhar',
            component: Consultoria,
            beforeEnter: (to, from, next) => {
                if (temAcesso('APPSE-FORN-CONS-00')) {
                    next()
                }
            }
        }
    ]
}
